import { CheckCheck, SquarePen } from "lucide-react";
import { getInitials } from "creso-core/utils";
import { Avatar } from "web-core";
import { Badge, Button } from "web-design-system";

export function HolderCard({
  name,
  role,
  pan,
  mobile,
  email,
  isApproved,
  onEdit,
}: {
  name: string;
  role: string;
  pan: string;
  mobile: string;
  email: string;
  isApproved?: boolean;
  onEdit?: () => void;
}) {
  return (
    <div className="flex flex-col gap-4 rounded-lg bg-muted p-4">
      <div className="flex items-center justify-between gap-3">
        <div className="flex min-w-0 items-center gap-2">
          <Avatar fallback={getInitials(name)} size="sm" />
          <div className="flex min-w-0 flex-col">
            <span className="truncate text-sm font-semibold">{name}</span>
            <span className="text-xs text-muted-foreground">{role}</span>
          </div>
        </div>
        <div className="flex shrink-0 items-center gap-3">
          {isApproved ? (
            <Badge
              variant="custom"
              className="gap-1 bg-tag-green text-tag-green-foreground"
            >
              <CheckCheck className="size-3.5" />
              Approved
            </Badge>
          ) : (
            <Badge
              variant="custom"
              className="bg-tag-yellow text-tag-yellow-foreground"
            >
              Approval pending
            </Badge>
          )}
          {onEdit ? (
            <Button
              type="button"
              variant="outline"
              size="icon"
              onClick={onEdit}
            >
              <SquarePen className="size-4" />
            </Button>
          ) : null}
        </div>
      </div>
      <div className="grid grid-cols-3 gap-4">
        <div className="flex min-w-0 flex-col">
          <span className="text-xs text-muted-foreground">PAN</span>
          <span className="truncate text-sm">{pan}</span>
        </div>
        <div className="flex min-w-0 flex-col">
          <span className="text-xs text-muted-foreground">Mobile</span>
          <span className="truncate text-sm">{mobile}</span>
        </div>
        <div className="flex min-w-0 flex-col">
          <span className="text-xs text-muted-foreground">Email</span>
          <span className="truncate text-sm">{email}</span>
        </div>
      </div>
    </div>
  );
}
